import type { ITransaction } from '../../../private/db/interface';
import Schema from './schema';

const VERSION = 4;

export default Object.freeze({
    version: VERSION,
    description: 'ITourTranslationDto PK change #name->#tourSupportedLanguageId (part.2)',
    mappingsChanges: Schema(VERSION),
    upgrade: async (transaction: ITransaction) => {
        /* ITourSupportedLanguage - change PK from name to tourSupportedLanguageId,
           Remove all items & force re-insertion, triggering PK change */
        const tableOld = transaction.table('ITourTranslationDto_tmp');
        const tableNew = transaction.table('ITourTranslationDto');
        const collection = tableOld.toCollection();
        const keys = await collection.keys();
        const items = await collection.toArray();

        await tableNew.bulkAdd(items);
        await tableOld.bulkDelete(keys);
    },
});
